import React from 'react';
import { Create, SimpleForm, ReferenceInput, TextInput, SelectInput, required } from 'react-admin';

const subsidiaryRenderer = choice => `${choice.name} (${choice.id})`;

const LimitGroupCreate = props => (
	<Create {...props}>
		<SimpleForm variant="standard">
			<ReferenceInput
				source="subsidiaryId"
				reference="subsidiaries"
				validate={required()}
			>
				<SelectInput optionText={subsidiaryRenderer} />
			</ReferenceInput>
			<TextInput source="description" />
		</SimpleForm>
	</Create>
);

export default LimitGroupCreate;


